(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-drag-verify2", [], factory);
	else if(typeof exports === 'object')
		exports["vue-drag-verify2"] = factory();
	else
		root["vue-drag-verify2"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition